export class Goals
{
  constructor(
    public carbs: number,
    public fat: number,
    public protein: number,
    public alcohol: number,
    public totalCalories: number,
    public carbCalories: number,
    public fatCalories: number,
    public proteinCalories: number,
    public alcoholCalories: number,
    public carbsPercentage: number,
    public fatPercentage: number,
    public proteinPercentage: number,
    public alcoholPercentage: number
  ){}
}
